let focusedMove: number | null = null;
let moveFlash = 0;

function elementsWith(attribute: string, value: string): HTMLElement[] {
  return [...document.querySelectorAll<HTMLElement>(`[${attribute}="${CSS.escape(value)}"]`)];
}

export function focusMove(id: number): void {
  if (focusedMove === id) return;
  focusedMove = id;
  document.querySelectorAll<HTMLElement>("[data-move-id]").forEach((element) => {
    const matches = Number(element.dataset.moveId) === id;
    element.classList.toggle("active-move", matches);
    element.classList.toggle("muted", !matches);
  });
}

export function clearMoveFocus(): void {
  focusedMove = null;
  document.querySelectorAll<HTMLElement>("[data-move-id].active-move, [data-move-id].muted")
    .forEach((element) => element.classList.remove("active-move", "muted"));
}

export function flashMove(id: number, duration = 1600): void {
  const token = ++moveFlash;
  focusMove(id);
  window.setTimeout(() => {
    if (token === moveFlash) clearMoveFocus();
  }, duration);
}

export function focusComparison(id: string, origin: HTMLElement): void {
  elementsWith("data-comparison-id", id).forEach((element) => {
    element.classList.toggle("comparison-origin", element === origin);
    element.classList.toggle("comparison-peer", element !== origin);
  });
}

export function clearComparisonFocus(id: string): void {
  elementsWith("data-comparison-id", id)
    .forEach((element) => element.classList.remove("comparison-origin", "comparison-peer"));
}

export function flashComparison(id: string, origin: HTMLElement, duration = 1600): void {
  focusComparison(id, origin);
  window.setTimeout(() => clearComparisonFocus(id), duration);
}

export function focusWord(id: string, origin: HTMLElement): void {
  elementsWith("data-word-comparison-id", id).forEach((element) => {
    element.classList.toggle("word-comparison-origin", element === origin);
    element.classList.toggle("word-comparison-peer", element !== origin);
  });
}

export function clearWordFocus(id: string): void {
  elementsWith("data-word-comparison-id", id)
    .forEach((element) => element.classList.remove("word-comparison-origin", "word-comparison-peer"));
}
